import { useState } from 'react';

const useForm = initialValues => {
    const [values, setValues] = useState(initialValues);

    return [
        values,
        e => {
            const finalValue = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

            setValues({
                ...values, //all values
                [e.target.name]: finalValue //overwrites one of the previous value that has changed
            })
        },
        () => setValues(initialValues), //reset the values
        (newValues) => {
            setValues(currentState => ({ ...currentState, ...newValues }))
        } //set the values without an event object
    ]
}

export default useForm;